import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Utils } from '../helper/utils';
import { LoginService } from '../services/login.service';
import { ProSessionInfoService } from '@totvs/protheus-lib-core';
import * as _ from 'lodash';

@Injectable()

export class HttpInterceptorReq implements HttpInterceptor {
  constructor(
    private utils: Utils,
    private loginService: LoginService,
    private proSessionInfoService: ProSessionInfoService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers = this.utils.getHeaders(false, true, req.url);
    const noExecuteEndpoint: boolean = this.loginService.isProtheusLogged() ? this.proSessionInfoService.getErpAppConfig().api_baseUrl === req.url : false;

    if (!noExecuteEndpoint) {
      req = req.clone({ setHeaders: headers });
      return next.handle(req);
    } else {
      const mockResponse: HttpEvent<any> = new HttpResponse({ //-- Cancela requisição da API base para que não ocorra erro ao chamar o lookup.
        status: 200,
        body: { items: [] },
        url: req.url,
      });

      return of(mockResponse);
    }
  }

}
